
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import LayoutsGuest from '@/layouts/Guest.vue'
import LoginForm from '@/components/LoginForm.vue' 
import BaseShadowCard from '@/components/BaseShadowCard.vue'

export default defineComponent({
  components: { LayoutsGuest, LoginForm, BaseShadowCard },
  setup() {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
